import React from 'react';

import AndesMessageIntervention from './messageintervention-chunk';
import useIntervention from './hooks/use-message-intervention';

const ChunkListingDisclaimer = () => {
  const intervention = useIntervention();

  return intervention ? <AndesMessageIntervention intervention={{ ...intervention }} /> : null;
};

export default ChunkListingDisclaimer;
